/*
 * .filter(Boolean) that Typescript understands
 */

export function truthy<T>(value: T | null | undefined | false): value is T {
    return Boolean(value);
}
